import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import XRegExp from 'xregexp'

//prefixes for lookbehind and lookahead patterns, see
//https://docs.oracle.com/javase/8/docs/api/java/util/regex/Pattern.html
var lookPrefixes = [ '(?=', '(?!', '(?<=', '(?<!' ]

/**
 * General equation parser shared by metric and dataset field equations.
 */
function EquationParser(options) {
	// the patterns to look for references, e.g. the pattern that matches M(1)
	this.patternKeys = options.patternKeys
	// the methods used to process different types of function references.  the
	// methods listed in this array correspond to the patterns in the patternKeys array
	this.methods = options.methods
	// cache of regular expressions and lookbehind/lookahead strings.  built in
	// the init method
	this.regExps = []
	this.lookStrs = []
}

_.extend(EquationParser.prototype, {

	_init: function() {
		if (!_.isEmpty(this.regExps)) {
			return
		}

		// add support for missing JavaScript RegExp features
		_.each(this.patternKeys, function(key, patternIndex) {
			var pattern = constants[key] || key

			// handle lookbehind and lookahead
			var lookExp = _.find(lookPrefixes, function (prefix) {
				return pattern.indexOf(prefix) === 0
			})
			if (lookExp) {
				var lookExpEnd = pattern.indexOf(')')
				this.lookStrs[patternIndex] = pattern.substr(0, lookExpEnd+1)
				pattern = pattern.substr(lookExpEnd+1, pattern.length)
			}

			// see https://stackoverflow.com/a/62032796/393274
			// see also the "Using unicode regular expressions" section in
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#advanced_searching_with_flags
			// \p{L} matches any kind of letter from any language
			// \p{M} matches Arabic diacritics
			pattern = pattern.replace('\\p\{IsAlphabetic\}', '\\p\{L\}\\p\{M\}')

			this.regExps[patternIndex] = new RegExp(pattern, 'iu')
		}.bind(this))
	},

	_search: function(equation, expIndex) {
		if (this.lookStrs[expIndex]) {
			return XRegExp.searchLb(equation, this.lookStrs[expIndex], this.regExps[expIndex])
		} else {
			return equation.search(this.regExps[expIndex])
		}
	},

	_exec: function(equation, expIndex) {
		if (this.lookStrs[expIndex]) {
			return XRegExp.execLb(equation, this.lookStrs[expIndex], this.regExps[expIndex])
		} else {
			return this.regExps[expIndex].exec(equation)
		}
	},

	parse: function(equation) {
		this._init()
		equation = equation || ''
		// locations of matches found in the equation
		var searches = _.map(this.regExps, function(regExp, index) {
			return this._search(equation, index)
		}.bind(this))
		var found = _.filter(searches, function(s) { return s > -1 })
		var results = []
		var advanced = 0 //how far we've advanced in the equation
		while (found.length > 0) {
			// gather data
			var min = _.min(found)
			var minIndex = _.indexOf(searches, min)
			var regExp = this.regExps[minIndex]
			var method = this.methods[minIndex]

			// extract and process the match
			var parsed = this._exec(equation, minIndex)
			var result = this[method](parsed)
			result.index = advanced + min
			results.push(result)

			// move forward so we can continue parsing
			var advance = min + parsed[0].length
			advanced += advance
			searches = _.map(searches, function(search) {
				return search == -1 ? search : search - advance
			})
			equation = equation.substring(advance)
			// try again to match the equation to the regexp we just matched it
			// too, in case it matches multiple times
			searches[minIndex] = this._search(equation, minIndex)
			found = _.filter(searches, function(s) { return s > -1 })
		}
		return results
	}

})

export default EquationParser

EquationParser.__filename__ = 'components/equations/equation-parser.js'
